import { render, staticRenderFns } from "./pemberitahuan.vue?vue&type=template&id=eaa2bb8a&"
import script from "./pemberitahuan.vue?vue&type=script&lang=js&"
export * from "./pemberitahuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports